import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { PrivacyContent } from "@/components/PrivacyContent";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — IraqCert" },
      {
        name: "description",
        content:
          "IraqCert Privacy Policy. Learn how we collect, protect, and use your corporate and personal data in compliance with ISO standards and Iraqi federal law.",
      },
      { property: "og:title", content: "Privacy Policy — IraqCert" },
      {
        property: "og:description",
        content:
          "IraqCert Privacy Policy. Learn how we collect, protect, and use your corporate and personal data.",
      },
      { property: "og:url", content: absolute("/privacy") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/privacy") }, ...hreflangLinks("/privacy")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "Home", path: "/" },
            { name: "Privacy Policy", path: "/privacy" },
          ]),
        ),
      },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <PrivacyContent />
      </main>
      <Footer />
    </div>
  );
}
